import * as Yup from "yup";

import { createForm } from "../../forms";

import type { TypeSafeReactLocalization } from "../../../composites";

export enum WireTypeEnum {
  Domestic = "domestic",
  International = "international",
  None = "",
}

export type WireType = WireTypeEnum;

export const getWireTypeOptions = (
  domesticWireFee?: string,
  internationalWireFees?: Array<Record<string, string>>,
) => {
  return {
    "Domestic wire": {
      value: WireTypeEnum.Domestic,
      details: domesticWireFee
        ? `Typically same business day · ${domesticWireFee}`
        : "Typically same business day",
    },
    "International wire": {
      value: WireTypeEnum.International,
      details: internationalWireFees?.[0]?.amount
        ? `Typically 1 to 3 business days · $${internationalWireFees[0]?.amount}`
        : "Typically 1 to 3 business days",
    },
  };
};

export type WireTypeSelectorFormFields = {
  wireType: WireType;
};

const translateValidationSchema = ({ getString }: TypeSafeReactLocalization) =>
  Yup.object().shape({
    wireType: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
  });

const initialValues: WireTypeSelectorFormFields = {
  wireType: WireTypeEnum.None,
};

export const wireTypeSelectorForm = createForm({
  initialValues,
  translateValidationSchema,
});
